import TechStacks from "./TechStacks";
import TitleAndTextComponent from "./TitleAndTextComponent";

const MicroFrontEnd = ({ mfe, siteTheme, isDay }) => {
  return (
    <div
      className={`${
        isDay ? siteTheme.textColor : "text-neutral-400"
      }  flex flex-col items-center justify-center w-full px-2 md:px-0 mx-auto mb-20 md:mb-32 max-w-max-profile-content-width`}
    >
      <div className="relative flex flex-row items-center w-full">
        <div className="mr-2 flex-[0.5] h-[1px] bg-gradient-to-r from-transparent to-linesLight" />
        <p
          className={`flex-[1] text-lg sm:text-2xl text-center ${siteTheme.textColor} font-semibold uppercase w-fit`}
        >
          {mfe.title}
        </p>
        <div className="ml-2 flex-[0.5] h-[1px] bg-gradient-to-r from-linesLight to-transparent" />
      </div>
      <div className="flex flex-col w-full gap-10 mx-auto my-10 px-0 md:px-5 lg:px-0 max-w-max-content-width">
        <div className="flex flex-col md:flex-row md:gap-10 lg:gap-20 w-full overflow-hidden lg:px-0">
          <div className="w-full md:w-[50%]">
            <div className="relative flex items-center justify-start w-full">
              <div className="w-fit">
                <p
                  className={`${siteTheme.textColor} text-[10px] tracking-[0.1em] uppercase font-semibold font-saira`}
                >
                  Summary
                </p>
              </div>
            </div>
            <div className="mt-10 ml-0 md:ml-10">
              <p
                className={`${
                  isDay ? siteTheme.textColor : "text-neutral-400"
                } font-light text-[14px] tracking-[0.08em] leading-loose mb-10 font-saira`}
              >
                {mfe.summary}
              </p>
            </div>
          </div>
          <div className="w-full md:w-[50%]">
            <div className="w-full">
              <div className="relative px-0 md:px-5 lg:px-0">
                <p
                  className={`${siteTheme.textColor} text-[10px] tracking-[0.1em] uppercase font-semibold font-saira`}
                >
                  {mfe?.techStacksTools?.section}
                </p>
              </div>
            </div>
            <div className="grid items-center justify-center w-full grid-cols-1 sm:grid-cols-4 lg:grid-cols-3 gap-2 px-0 md:px-5 mt-10 lg:px-0">
              <TechStacks
                value={mfe?.techStacksTools?.api}
                widthAndheight="w-[80%] sm:w-full lg:w-[180px] h-[100px]"
                notRoundImg={true}
              />
              <TechStacks
                value={mfe?.techStacksTools?.deployment}
                widthAndheight="w-[80%] sm:w-full lg:w-[180px] h-[100px]"
                notRoundImg={true}
              />
              <TechStacks
                value={mfe?.techStacksTools?.languagesAndFrameworks}
                widthAndheight="w-[80%] sm:w-full lg:w-[180px] h-[100px]"
                notRoundImg={true}
              />
              <TechStacks
                value={mfe?.techStacksTools?.microFrontendTools}
                widthAndheight="w-[80%] sm:w-full lg:w-[180px] h-[100px]"
                notRoundImg={true}
              />
              <TechStacks
                value={mfe?.techStacksTools?.stateManagement}
                widthAndheight="w-[80%] sm:w-full lg:w-[180px] h-[100px]"
                notRoundImg={true}
              />
            </div>
          </div>
        </div>
        <div className="w-full">
          <div className="relative flex items-center justify-start w-full">
            <div className="w-fit">
              <p
                className={`${siteTheme.textColor} text-[10px] tracking-[0.1em] uppercase font-semibold font-saira`}
              >
                {mfe?.whyMFE?.question}
              </p>
            </div>
          </div>
          <div className="mt-10 ml-0 md:ml-10">
            <p
              className={`${
                isDay ? siteTheme.textColor : "text-neutral-400"
              } font-light text-[14px] tracking-[0.08em] leading-loose mb-10 font-saira`}
            >
              {mfe?.whyMFE?.answer}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center md:px-5 lg:px-0 w-full mx-auto max-w-max-content-width">
        <div className="relative flex flex-row items-center w-full mx-auto mb-5">
          <div className="mr-2 flex-[0.5] h-[1px] bg-gradient-to-r from-transparent to-linesLight" />
          <p
            className={`${siteTheme.textColor} text-[10px] tracking-[0.1em] uppercase font-thin font-saira`}
          >
            {mfe?.keySkillsAndExperise?.section}
          </p>
          <div className="ml-2 flex-[0.5] h-[1px] bg-gradient-to-r from-linesLight to-transparent" />
        </div>
        <div className="columns-1 md:columns-2">
          <TitleAndTextComponent
            value={mfe?.keySkillsAndExperise?.agbc}
            isDay={isDay}
          />
          <TitleAndTextComponent
            value={mfe?.keySkillsAndExperise?.ctc}
            isDay={isDay}
          />
          <TitleAndTextComponent
            value={mfe?.keySkillsAndExperise?.ideploy}
            isDay={isDay}
          />
          <TitleAndTextComponent
            value={mfe?.keySkillsAndExperise?.mfa}
            isDay={isDay}
          />
          <TitleAndTextComponent
            value={mfe?.keySkillsAndExperise?.mfw}
            isDay={isDay}
          />
          <TitleAndTextComponent
            value={mfe?.keySkillsAndExperise?.monorepos}
            isDay={isDay}
          />
          <TitleAndTextComponent
            value={mfe?.keySkillsAndExperise?.po}
            isDay={isDay}
          />
          <TitleAndTextComponent
            value={mfe?.keySkillsAndExperise?.smmfe}
            isDay={isDay}
          />
          <TitleAndTextComponent
            value={mfe?.keySkillsAndExperise?.spa}
            isDay={isDay}
          />
        </div>
      </div>
    </div>
  );
};

export { MicroFrontEnd };
export default MicroFrontEnd;
